import i18n from '@/Config/app/i18n';
import {
  AssistantProvider,
  AssistantSourceDto,
} from '@/Domain/api/Conversation/dto/AssistantSource.dto';
import { ConversationSourceEnum } from '@/Domain/enum/ConversationSource.enum';

// Keep in sync with PUBLIC_WEBSITE_PROVIDERS in quickchat/api/public_assistant/source.py.
const legacyProviders: Partial<Record<ConversationSourceEnum, AssistantProvider>> = {
  [ConversationSourceEnum.PUBLIC_QUESTION]: 'Unknown',
  [ConversationSourceEnum.PUBLIC_QUESTION_CHATGPT]: 'OpenAI',
  [ConversationSourceEnum.PUBLIC_QUESTION_CLAUDE]: 'Anthropic',
  [ConversationSourceEnum.PUBLIC_QUESTION_PERPLEXITY]: 'Perplexity',
};

export const isPublicAssistantSource = (source: ConversationSourceEnum): boolean =>
  source in legacyProviders;

export const assistantProvider = (
  source: ConversationSourceEnum,
  evidence?: AssistantSourceDto | null,
): AssistantProvider => evidence?.identity_claim.provider ?? legacyProviders[source] ?? 'Unknown';

export const publicAssistantLabel = (
  source: ConversationSourceEnum,
  evidence?: AssistantSourceDto | null,
): string => {
  const provider = assistantProvider(source, evidence);
  const label =
    provider === 'Unknown'
      ? i18n.t('inbox_v2:assistant_source.unknown')
      : i18n.t('inbox_v2:assistant_source.provider_claim', { provider });
  const role = evidence?.identity_claim.declared_fetch_role;
  return role && role !== 'unknown'
    ? `${label}. ${i18n.t(`inbox_v2:assistant_source.roles.${role}`)}`
    : label;
};
